export default __webpack_public_path__ + "static/media/Amelie 9781408308165.9fba55c2.jpg";